import { LOCALE } from './constants';

export const formatToPercentage = number => {
  const formatter = new Intl.NumberFormat(LOCALE, {
    style: 'percent',
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });
  return formatter.format(number / 100);
};

export const converDecimalToPercentage = number => {
  const formatter = new Intl.NumberFormat(LOCALE, {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return formatter.format(number);
};

export const formatToCurrency = (number, currency = 'USD') => {
  const formatter = new Intl.NumberFormat(LOCALE, {
    style: 'currency',
    currency,
  });
  return formatter.format(number);
};
